export enum SystemAlert {
    Unknown = 0,
    EvaluationSentForApprovement = 1,
    EvaluationApprovementRequestProcessed = 2,
    EvaluationAvailableToContinue = 3,
    NewQuestionnaireAvailable = 4,
    QuestionnaireReviewRequired = 5,
    ThirdpartyQuestionnaireAnswred = 6,
    NewDueDiligenceRequestAvailable = 7,
    DueDiligenceCompletedWithEvaluation = 8,
    DueDiligenceCompletedNoEvaluation = 9
}
